// 会员权益相关api接口
import request from '@/utils/request'
import { tansParams } from '@/utils'

// 我的会员权益汇总
export const queryMyMemberBenefitRecord = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/memberBenefitRecord/myMemberBenefitRecord',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 会员权益使用记录
export const queryMemberBenefitUseRecord = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/memberUseRecord/useRecordPager',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

/**
 * 前置校验会员权益
 * @param {*} params memberBenefit：会员权益编码；memberType：会员类型，默认值 DEFAULT
 * @returns
 */
export const checkMemberBenefit = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/memberRecord/checkMemberBenefit',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询订单记录
export const queryOrderRecord = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/orderRecord/orderRecordPager',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 取消订单
export const cancelOrder = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/orderRecord/cancelOrder',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 保存申请开票信息
export const saveApplyInvoiceInfo = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/orderRecord/applyInvoice',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 分页查询待开发票的订单
export const queryOrderRecordInvoice = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/orderRecord/orderRecordInvoice',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询我的开票记录
export const queryInvoiceRecordPager = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/invoiceRecord/invoiceRecordPager',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 保存开票抬头信息
export const saveUserInvoiceInfo = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iUserInfo/updateUserInfo',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询会员价格(根据用户id)
export const queryMemberPriceByUserId = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/itemEventPromotion/mapBuyMemberVO',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 生成订单记录
export const createOrderInfo = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/orderRecord/createOrder',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 立即付款（上传打款证明）
export function uploadPaymentVoucher(data) {
	// 以action的形式立即上传
	// return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/orderRecord/immediatelyPay'
	// 以文件流的形式上传
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/orderRecord/immediatelyPay',
		method: 'post',
		isShowLoader: false,
		headers: {
			'Content-Type': 'multipart/form-data',
			isToken: true
		},
		data
	})
}

// 材料下载
export function downloadFileRecord(params) {
	return (
		process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/fileRecord/downloadFile?' + tansParams(params)
	)
}

// 材料预览
export function previewFileRecord(params) {
	return (
		process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/fileRecord/previewFile?' + tansParams(params)
	)
}
